import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '@lib/components/Input/Input';
import { InputSizes } from '@lib/components/Input/enums';
import TabBar from '@lib/components/TabBar/TabBar';
import { TabBarItem } from '@lib/components/TabBar/constants';
import styles from '../SelectPanel.module.scss';

type SelectPanelHeaderProps = {
  activeTab?: string;
  name: string;
  onSearchChange: (value: string) => void;
  onTabChange?: (item: TabBarItem) => void;
  searchable: boolean;
  searchPlaceholder?: string;
  searchQuery: string;
  searchInputRef: React.RefObject<
    HTMLInputElement | HTMLTextAreaElement | null
  >;
  showTabs: boolean;
  tabItems?: TabBarItem[];
};

export function SelectPanelHeader({
  activeTab,
  name,
  onSearchChange,
  onTabChange,
  searchable,
  searchPlaceholder,
  searchQuery,
  searchInputRef,
  showTabs,
  tabItems = [],
}: SelectPanelHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      {searchable && (
        <div className={styles.search}>
          <Input
            ref={searchInputRef}
            name={`${name}-select-panel-search`}
            placeholder={searchPlaceholder ?? t('search')}
            leftIcon="search"
            value={searchQuery}
            onChange={(event) => onSearchChange(event.target.value)}
            onClear={() => onSearchChange('')}
            size={InputSizes.medium}
          />
        </div>
      )}
      {showTabs && tabItems.length > 0 && (
        <TabBar
          active={activeTab}
          items={tabItems}
          onActiveChange={(item) => onTabChange?.(item)}
          useSidePaddings={false}
          className={styles.tabs}
        />
      )}
    </div>
  );
}
